"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdateBasketItemEvent = exports.Name = void 0;
const Name = exports.Name = 'update-basket-item';
const UpdateBasketItemEvent = exports.UpdateBasketItemEvent = Name;
